import $ from "jquery";

export default (function () {
    var init = function () {

        $("input[name='ChosenPledgeAmountId']").change(onPledgeAmountChange);
        $("#choosePledgeAmount").on("keyup", "label", onKeyUpRB);
    };

    var onPledgeAmountChange = function () {
        var $radioButton = $("input[name='ChosenPledgeAmountId']:checked");
        var $pOtherPledgeAmount = $(".js-other-pledge-amount");

        if ($radioButton.hasClass("js-default-pledge-option")) {
            $pOtherPledgeAmount.removeClass("is-hidden");
            document.getElementById("PledgeAmount").focus();
        } else {
            $pOtherPledgeAmount.addClass("is-hidden");
        }
    };

    var onKeyUpRB = function (e) {
        if (e.keyCode == 32) {
            var $label = $(document.activeElement);
            $label
                .closest("div")
                .children("input[type=radio]")
                .prop("checked", true);
            onPledgeAmountChange();
        }
    };

    return {
        init: init
    };
})();


